"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var CalendarArrow = function CalendarArrow(_ref) {
  var className = _ref.className;
  return _react["default"].createElement("svg", {
    className: className,
    width: "52",
    height: "52",
    viewBox: "0 0 54.818 60.277",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("path", {
    d: "M 11.376953,0 A 1.268,1.268 0 0 0 10.111328,1.2636719 V 6.7421875 H 5.0566406 A 5.057,5.057 0 0 0 0,11.800781 v 37.076172 a 5.057,5.057 0 0 0 5.0566406,5.054688 H 27.125 c -0.675147,-0.93227 -1.254578,-1.930005 -1.707031,-3 -0.283194,-0.669717 -0.499924,-1.358269 -0.683594,-2.054688 H 5.6875 A 0.634,0.634 0 0 1 5.0566406,48.244141 V 16.853516 H 42.134766 v 13.05664 c 1.142726,0.197218 2.260372,0.511163 3.33789,0.966797 0.59579,0.251933 1.164398,0.551218 1.71875,0.873047 V 11.800781 A 5.057,5.057 0 0 0 42.134766,6.7421875 H 37.078125 V 1.2636719 A 1.268,1.268 0 0 0 35.814453,0 H 31.599609 A 1.268,1.268 0 0 0 30.335938,1.2636719 V 6.7421875 H 16.853516 V 1.2636719 A 1.268,1.268 0 0 0 15.589844,0 Z m 30.757813,32.958984 v 7.50586 l 4.068359,4.09375 c 0.233139,0.233139 0.233139,0.604749 0,0.83789 l -5.669922,5.699219 c -0.120279,0.12188 -0.269714,0.175781 -0.416015,0.175781 -0.306217,0 -0.601563,-0.23849 -0.601563,-0.597656 V 48.876953 H 27.857422 c 0.652307,1.949709 1.777412,3.677879 3.242187,5.054688 h 11.035157 a 5.057,5.057 0 0 0 5.05664,-5.054688 V 35.369141 c -1.453024,-1.162357 -3.173111,-2.00171 -5.05664,-2.410157 z"
  }), _react["default"].createElement("path", {
    d: "M 39.515625 32.673828 C 32.719894 32.673828 27.214844 38.178878 27.214844 44.974609 C 27.214844 51.770339 32.719894 57.277344 39.515625 57.277344 C 46.311355 57.277344 51.818359 51.770339 51.818359 44.974609 C 51.818359 38.178878 46.311355 32.673828 39.515625 32.673828 z M 40.115234 38.677734 C 40.261541 38.677734 40.411344 38.731658 40.533203 38.853516 L 46.203125 44.558594 C 46.436264 44.791733 46.436264 45.163343 46.203125 45.396484 L 40.533203 51.095703 C 40.412924 51.217583 40.263489 51.271484 40.117188 51.271484 C 39.810971 51.271484 39.515625 51.032994 39.515625 50.673828 L 39.515625 47.158203 L 33.761719 47.158203 C 33.434337 47.158203 33.166016 46.889889 33.166016 46.5625 L 33.166016 43.386719 C 33.166016 43.059331 33.434337 42.792969 33.761719 42.792969 L 39.515625 42.792969 L 39.515625 39.275391 C 39.515625 38.916195 39.808919 38.677734 40.115234 38.677734 z ",
    stroke: "none"
  }));
};

CalendarArrow.displayName = 'CalendarArrow';
CalendarArrow.propTypes = {
  className: _propTypes["default"].string
};
CalendarArrow.defaultProps = {
  className: ''
};
var _default = CalendarArrow;
exports["default"] = _default;